/**
 * Created by contrapro on 03/04/2018
 */

import { ACTION_TYPE_SHOW_RICH_MODAL, ACTION_TYPE_CLOSE_RICH_MODAL } from '../actions';

const initialState = {
    modal: false,

    title: '',
    content: '',
    onOK:null,
    onCancel:null,
    okText:'',
    cancelText:'',
    imgUrl:'',

    msgList: []
};

export default function richModalReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPE_SHOW_RICH_MODAL:
            const msg = {
                title: action.payload.data.title,
                content: action.payload.data.content,
                onOK: action.payload.data.onOK,
                onCancel: action.payload.data.onCancel,
                modal: true,
                imgUrl:action.payload.data.imgUrl,
                okText:action.payload.data.okText,
                cancelText:action.payload.data.cancelText
            };

            if (state.msgList.length > 0) {
                const latest = state.msgList[state.msgList.length - 1];
                if (msg.title === latest.title
                    && msg.content === latest.content
                    && msg.okText === latest.okText
                    && msg.cancelText === latest.cancelText) {
                    console.log('同样的玩意',msg, latest);
                    return state;
                }
            }

            const l1 = state.msgList.slice();
            l1.push(msg);

            return {
                ...state,
                ...msg,
                msgList: l1
            };

        case ACTION_TYPE_CLOSE_RICH_MODAL:

            const l = state.msgList.slice();

            if (l.length > 1) {
                const last = l.shift(); //这里要用队列，不能pop
                return {
                    ...state,
                    ...last,
                    msgList:l
                }
            } else {
                return {
                    ...state,
                    title: '',
                    content: '',
                    modal: false,
                    onOK: null,
                    onCancel: null,
                    imgUrl:'',
                    okText:'',
                    cancelText:'',
                    msgList:[]
                };
            }



        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/reducers/richModalReducer.js